import { FileParameter } from "services/api/cplapi/CPLAPI";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export class ExternalAccessCommentModel implements IExternalAccessCommentModel {
  singleUseToken?: string;
  message?: string | undefined;
  attachments?: FileParameter[] | undefined;

  constructor(data?: IExternalAccessCommentModel) {
    if (data) {
      for (const property in data) {
        if (Object.hasOwn(data, property)) (this as any)[property] = (data as any)[property];
      }
    }
  }
}

export interface IExternalAccessCommentModel {
  singleUseToken?: string;
  message?: string | undefined;
  attachments?: FileParameter[] | undefined;
}
